import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CartItems from './components/CartItems'


const CartItemsList = (props) => (

    <Container>
        <CartItems {...props} />
    </Container>
);

CartItemsList.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(CartItemsList);